import { BaseSurvey } from '../base-survey';
import { FactorySurveyView } from './factory-view';
import { validateAdinsightRecommendationTriggerCondition } from '../utils';

export class AdInsightRecommendationMccSurvey extends BaseSurvey {
  getSurveyName = () => 'AdInsightRecommendationMccSurvey';

  getSurveyId = isTestEnv => isTestEnv ? // eslint-disable-line no-confusing-arrow
    '9c362445-37e0-46b2-9389-c70570320aff' : '557a4b31-a852-4ef8-8b79-73680df161a9';

  getInitializationConfig = () => ({
    initGroup: 100,
    initStartDate: '2023-03-02',
    initEndDate: '2023-06-09',
  });

  validateTriggerCondition = () => validateAdinsightRecommendationTriggerCondition(this, 'campaign/vnext/accounts/recommendations', 'IsRecommendationMccPageCsatPilotEnabled');

  getSurveyComponent = () => FactorySurveyView;
}
